export const NAME_START_REGEX = /^[\da-z]/;
export const NAME_END_REGEX = /[\da-z]$/;
export const NAME_CONTENT_REGEX = /^[\da-z-]+$/;
export const NAME_OPENAPI_REGEX = /^[\da-z][\da-z-]*[\da-z]$/;
